var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserProfiles',{staticStyle:{"margin-bottom":"1.75rem"},attrs:{"limit":5}},[_c('div',{staticStyle:{"margin-top":"1rem"}},[_c('Button',{attrs:{"to":"/profiles","size":"small"}},[_vm._v("View all profiles")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }